import { Markdown } from 'components';
import { AppContext } from 'providers/AppContext';
import { useContext, useState } from 'react';

type RiskqTextRRSURowProps = Readonly<{
	text: string;
	title: string;
}>;

export function RiskqTextRRSURow(props: RiskqTextRRSURowProps) {
	const { t } = useContext(AppContext);
	const [visible, setVisible] = useState(false);
	const toggle = () => setVisible(!visible);
	return (
		<div className="my-4" key={props.text}>
			<button className="bold text-secondary toggle" onClick={toggle} type="button">
				{t(props.title, 'riskq')}
			</button>
			{visible && (
				<div className="arionui">
					<Markdown>{t(props.text, 'testRisk')}</Markdown>
				</div>
			)}
		</div>
	);
}
